import React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/component/ds/utils';

/* "Label" in Figma. Error colour comes from data-error, set by the caller.
 * The control row owns the layout, so `inline` stays a plain inline box --
 * as a flex container it got its own baseline and sat off-centre. */
const labelVariants = cva(
  [
    'ds-text-ds-sm ds-text-foreground',
    'data-[error=true]:ds-text-destructive',
    'peer-disabled:ds-cursor-default peer-disabled:ds-opacity-50'
  ],
  {
    variants: {
      layout: { block: 'ds-block', inline: 'ds-inline' },
      weight: { normal: 'ds-font-normal', medium: 'ds-font-medium' }
    },
    defaultVariants: { layout: 'block', weight: 'medium' }
  }
);

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
  VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, layout, weight, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ layout, weight }), className)}
      {...props}
    />
  )
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label, labelVariants };
